import { SVGProps } from "react";

interface CheckRoundIconProps extends SVGProps<SVGSVGElement> {
  fillColor?: string;
}
const CheckRoundIcon = ({ className = "", fillColor = "#24C452", ...props }: CheckRoundIconProps) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    className={`rounded-full bg-white ${className}`}
  >
    <g clipPath="url(#a)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 24C5.374 24 0 18.626 0 12S5.374 0 12 0s12 5.374 12 12-5.374 12-12 12m-1.651-9.889 7.201-7.2a.644.644 0 0 1 .905 0l.817.816a.646.646 0 0 1 0 .905l-8.458 8.458a.64.64 0 0 1-.563.176.63.63 0 0 1-.37-.18l-5.152-5.151a.644.644 0 0 1 0-.905l.817-.817a.64.64 0 0 1 .905 0z"
        fill={fillColor}
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default CheckRoundIcon;
